import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate";
import Button from "../../../component/visible/Button";
import Message from "../../../Message";

export default class EndcardCloseBtn extends SingleOfferTemplate {
    constructor(...props) {
        super(...props)
        this.name = 'EndcardCloseBtn';
    }

    initComponents() {
        super.initComponents()
        this.closeBtn = new Button({
            type: "close",
            onClick: function () {
                console.log("关闭按钮点击逻辑")
                Message.emitMessageToSuperView('MTG_TriggerCloseBtn')
            }
        })
        this.closeBtn.appendTo(document.querySelector('.mtgClose'));
        this.closeBtn.show();
    }

    bindPageEvent() {
        super.bindPageEvent()

        // const closeBtn = document.querySelector('.mtgClose')
        // if (closeBtn) {
        //     closeBtn.addEventListener('click', () => {
        //         // App.onBroadcast(App.unit.id, 'readyToShow', {a:true})
        //         console.log('关闭按钮被点击-')
        //         this.hide()
        //         App.closeAd()
        //     }, false)
        // }
    }

    /**
     * 绑定native组件各个事件
     */
    bindNativeEvent() {
    }

    initSlots() {
        super.initSlots()
    }

    /**
     * 销毁组件
     */
    destory() {
        super.destory()
        this.closeBtn && this.closeBtn.destory()
    }
}